import { useContext } from "react";
import AuthContext from "../../contexts/AuthContext";
import WBCYearsContext from "../../contexts/WBCYearsContext";

const useHasNonCurrentYearAccess = () => {
  const { isWBCI, isTeamCoordinator } = useContext(AuthContext).state;
  const { isCurrentYearSelected } = useContext(WBCYearsContext);

  return isWBCI || isCurrentYearSelected || isTeamCoordinator;
};

export default useHasNonCurrentYearAccess;
